import React from 'react';
import styled from 'styled-components';

const ListItemWrapper = styled(({ startWithGrey, onClick, ...restProps }) => (
  <div onClick={onClick} {...restProps} />
))`
  display: flex;
  & .listItem {
    border-bottom: 1px solid transparent;
  }

  ${({ startWithGrey, theme }) => `&:nth-child(${startWithGrey ? 'even' : 'odd'}) .listItem {
    width: 100%;
    background: ${theme.palette.background.default};
  }`};

  ${({ onClick, theme }) => `&:hover .listItem {
    border-bottom: ${!!onClick ? `1px solid ${theme.config.appbarColors.borderColor}` : ''};
  }`};
`;

export default ListItemWrapper;
